import _extends from '@babel/runtime/helpers/extends';
import React__default, { useEffect } from 'react';
import { S as Shroud, H as Header, C as CloseButton, a as CloseButtonIcon, b as Content } from './SecondaryView.styles-DuNrzAq4.js';
import { V as View } from './View-D64ZsWTO.js';
import { I as InlinePortalProvider } from '../Portal/InlinePortalProvider-DpZ1TsoC.js';
import { F as Flex } from '../Flex/Flex-DIrgiHUL.js';
import { u as useTaktId } from '../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';
import { u as useDetectVirtualKeyboard } from '../LocalModules/storm-ui-utils/dist/esm/virtualKeyboard/useDetectVirtualKeyboard-XkMJ_5y1-XkMJ_5y1.js';
import { P as PreventScroll } from '../LocalModules/storm-ui-utils/dist/esm/PreventScroll-C7cxX_Px-zZoGpe3b.js';
import { E as angleInlineStart } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-9_jhfe7X-DyCR5FH7.js';

function createSetSizeToVisualViewport(containerRef) {
  return function setSizeToVisualViewport() {
    if (containerRef.current instanceof HTMLDivElement && window.visualViewport) {
      // To fix issue caused by virtual keyboard
      const {
        height,
        width
      } = window.visualViewport;
      const {
        style
      } = containerRef.current;
      style.height = `${height}px`;
      style.width = `${width}px`;
    }
  };
}
const Overlay = ({
  fadeDuration,
  transitionState,
  handleKeyDown,
  handleKeyUp,
  containerRef,
  onClose,
  closeButtonRef,
  closeButtonLabel,
  closeButtonProps,
  padding = 'base',
  paddingBlockStart,
  paddingBlockEnd,
  paddingInlineStart,
  paddingInlineEnd,
  children,
  ...rest
}) => {
  const {
    getDataTaktAttributes: getCloseButtonDataTaktAttributes
  } = useTaktId({
    taktId: closeButtonProps === null || closeButtonProps === void 0 ? void 0 : closeButtonProps.taktId,
    fallbackId: createStormTaktId('close-button')
  });
  const [isVirtualKeyboardOpen] = useDetectVirtualKeyboard();
  useEffect(() => {
    if (typeof window !== 'undefined' && 'visualViewport' in window && window.visualViewport) {
      const {
        visualViewport
      } = window;
      if (isVirtualKeyboardOpen) {
        const setSizeToVisualViewport = createSetSizeToVisualViewport(containerRef);
        visualViewport.addEventListener('resize', setSizeToVisualViewport);
        setSizeToVisualViewport();
        return () => {
          visualViewport.removeEventListener('resize', setSizeToVisualViewport);
          setSizeToVisualViewport();
        };
      }
    }
    return () => undefined;
  }, [containerRef, isVirtualKeyboardOpen]);
  return /*#__PURE__*/React__default.createElement(PreventScroll, null, /*#__PURE__*/React__default.createElement(Shroud, {
    $transitionState: transitionState
  }, /*#__PURE__*/React__default.createElement(View, _extends({}, rest, {
    role: "presentation",
    $fadeDuration: fadeDuration,
    $fadeState: transitionState,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    ref: containerRef
  }), /*#__PURE__*/React__default.createElement(InlinePortalProvider, null, /*#__PURE__*/React__default.createElement(Header, null, /*#__PURE__*/React__default.createElement(CloseButton, _extends({
    onClick: onClose,
    ref: closeButtonRef,
    type: "button"
  }, getCloseButtonDataTaktAttributes({
    taktValue: closeButtonProps === null || closeButtonProps === void 0 ? void 0 : closeButtonProps.taktValue
  }), closeButtonProps), /*#__PURE__*/React__default.createElement(Flex, {
    alignItems: "center"
  }, /*#__PURE__*/React__default.createElement(CloseButtonIcon, {
    type: angleInlineStart,
    size: "base"
  }), closeButtonLabel))), /*#__PURE__*/React__default.createElement(Content, {
    $padding: padding,
    $paddingBlockStart: paddingBlockStart,
    $paddingBlockEnd: paddingBlockEnd,
    $paddingInlineStart: paddingInlineStart,
    $paddingInlineEnd: paddingInlineEnd
  }, children)))));
};

export { Overlay as O };
//# sourceMappingURL=Overlay-C63t_Ykg.js.map
